import { ReactNode } from 'react';
import { cn } from '@/lib/utils.ts';

interface HeadlineNumberProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  /** Wynik, którego jeszcze nie ma — wielka czarna zerówka czyta się jak fakt. */
  dimmed?: boolean;
}

/**
 * Główna liczba karty — obłożenie, saldo, konwersja lejka.
 *
 * Osobny komponent, bo ta jedna klasa stała przepisana ręcznie w czterech
 * kartach zdążyła się już rozjechać: jedna z nich zgubiła `tracking` i miała
 * `leading-none`. Karty na jednym ekranie muszą mieć tę samą wagę optyczną.
 */
const HeadlineNumber = ({
  children,
  dimmed = false,
  className,
  ...props
}: HeadlineNumberProps) => (
  <span
    className={cn(
      'text-[28px] font-extrabold tabular-nums tracking-[-.02em]',
      dimmed ? 'text-neutral-400' : 'text-ink',
      className,
    )}
    {...props}
  >
    {children}
  </span>
);

export default HeadlineNumber;
